/* =========================================
   ENQUIRY DRAWER
========================================= */

document.addEventListener("DOMContentLoaded", function () {

  const drawer = document.getElementById("enquiry-drawer");

  if (!drawer) return;

  const openButtons = document.querySelectorAll("[data-open-enquiry]");
  const closeButton = drawer.querySelector("[data-enquiry-drawer-close]");
  const underlay = drawer.querySelector("[data-enquiry-underlay]");

  const infoPage = drawer.querySelector('[data-enquiry-page="info"]');
  const bookingPage = drawer.querySelector('[data-enquiry-page="booking"]');

  const openBooking = drawer.querySelector("[data-open-booking]");
  const backButton = drawer.querySelector("[data-booking-back]");

  /* ---------------------------
      OPEN DRAWER
  ---------------------------- */

  function openDrawer() {

    drawer.classList.add("is-open");
    document.body.classList.add("drawer-open");

  }

  /* ---------------------------
      CLOSE DRAWER
  ---------------------------- */

  function closeDrawer() {

    drawer.classList.remove("is-open");
    document.body.classList.remove("drawer-open");

  }

  /* ---------------------------
      INFO PAGE
  ---------------------------- */

  function showInfoPage() {

    if (!infoPage || !bookingPage) return;

    infoPage.classList.remove("hidden");
    infoPage.classList.add("is-active");

    bookingPage.classList.add("hidden");
    bookingPage.classList.remove("is-active");

  }

  /* ---------------------------
      BOOKING PAGE
  ---------------------------- */

  function showBookingPage() {

    if (!infoPage || !bookingPage) return;

    infoPage.classList.add("hidden");
    infoPage.classList.remove("is-active");

    bookingPage.classList.remove("hidden");
    bookingPage.classList.add("is-active");

  }

  /* ---------------------------
      OPEN BOOKING
  ---------------------------- */

  if (openBooking) {

    openBooking.addEventListener("click", function () {

      showBookingPage();

    });

  }

  /* ---------------------------
      BACK BUTTON
  ---------------------------- */

  if (backButton) {

    backButton.addEventListener("click", function () {

      showInfoPage();

    });

  }

  /* ---------------------------
      OPEN DRAWER BUTTONS
  ---------------------------- */

  openButtons.forEach(function (button) {

    button.addEventListener("click", function (e) {

      e.preventDefault();

      openDrawer();
      showInfoPage();

    });

  });

  /* ---------------------------
      CLOSE BUTTON
  ---------------------------- */

  if (closeButton) {

    closeButton.addEventListener("click", closeDrawer);

  }

  /* ---------------------------
      UNDERLAY
  ---------------------------- */

  if (underlay) {

    underlay.addEventListener("click", closeDrawer);

  }

  /* ---------------------------
      ESC KEY
  ---------------------------- */

  document.addEventListener("keydown", function (e) {

    if (e.key === "Escape") {

      closeDrawer();

    }

  });

});